import { PageContainer } from './page-container';
import { PageContentAnimation } from './page-content-animation';
import { PageContentSections } from './page-content-sections';

interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <PageContainer>
      <PageContentAnimation>
        <PageContentSections className="gap-5">{children}</PageContentSections>
      </PageContentAnimation>
    </PageContainer>
  );
}
